import React from 'react';
import capitalize from '../../../utils/capitalize';
import keyExists from '../../../utils/keyExists';

import './DeviceReaderAndAntenna.scss';

export default function DeviceReaderAndAntenna(props) {
    const { device } = props;

    const readerStatusKey = 'currentState.raw.rfidStatus.reader';
    const antennaStatusKey = 'currentState.raw.rfidStatus.antennas';
    const settingsKey = 'metadata.raw.peripheralDevices.readerSettings';

    const readerStatus = keyExists(readerStatusKey, device) ? device.currentState.raw.rfidStatus.reader : null;
    const antennasStatus = readerStatus !== null && keyExists(antennaStatusKey, device) ? device.currentState.raw.rfidStatus.antennas : null;
    const readerSettings = keyExists(settingsKey, device) ? device.metadata.raw.peripheralDevices.readerSettings : null;

    if (!readerStatus && !antennasStatus && !readerSettings) {
        return (
            <div className="device-reader-and-antenna">
                <h2 className="no-reader">No reader and antenna information available.</h2>
            </div>
        );
    }

    return (
        <div className="device-reader-and-antenna">
            <div className="status-column">
                <ReaderStatus readerStatus={readerStatus} />
                <AntennaStatus antennasStatus={antennasStatus} />
            </div>
            <div className="setting-column">
                <ReaderSettings readerSettings={readerSettings} />
            </div>
        </div>
    );
}

function ReaderStatus({ readerStatus }) {
    return (
        <div className="operational-status reader-status">
            <h3 className="title">Reader Status</h3>
            {readerStatus ? (
                <div className="reader-status-values">
                    <span className="name"> Stora Enso Reader </span>
                    <span className={`status ${readerStatus.status === 'UP' ? 'up' : 'down'}`}>{readerStatus.status}</span>
                </div>
            ) : (
                <h4 className="no-info">No reader status information is available.</h4>
            )}
        </div>
    );
}

function AntennaStatus({ antennasStatus }) {
    return (
        <div className="operational-status antenna-status">
            <h3 className="title">Antenna Status</h3>
            {antennasStatus && Array.isArray(antennasStatus) && antennasStatus.length > 0 ? (
                antennasStatus.map(
                    (antenna, i) =>
                        antenna && (
                            <div className="antenna-status-values" key={i}>
                                <span className="name">{antenna.Name !== undefined ? antenna.Name : 'Antenna: ' + antenna.id}</span>
                                <span className={`status ${antenna.status === 'UP' ? 'up' : 'down'}`}>{antenna.status}</span>
                            </div>
                        )
                )
            ) : (
                <h4 className="no-info">No antenna status information is available.</h4>
            )}
        </div>
    );
}

function ReaderSettings({ readerSettings }) {
    return (
        <div className="operational-status reader-settings">
            <h3 className="title">Reader Settings</h3>
            {readerSettings && Array.isArray(readerSettings) && readerSettings.length > 0 ? (
                readerSettings.map((setting, i) => (
                    <div key={i}>
                        <h4 className="settingsName">{`Setting ${i + 1}:`}</h4>
                        {Object.entries(setting).map(([key, value]) => {
                            if (key === 'key' || key === 'id') {
                                return null;
                            }
                            return (
                                <div key={key}>
                                    <span className={`name`}>{`${capitalize(key)}: `}</span>
                                    <span className={`status`}>{value}</span>
                                </div>
                            );
                        })}
                    </div>
                ))
            ) : (
                <h4 className="no-info">No reader setting information is available.</h4>
            )}
        </div>
    );
}
